import "./style.scss";
import * as React from "react";
import { Tabs as AntDTabs } from "antd";
const TabPane = AntDTabs.TabPane;

class Tabs extends React.Component<any, any> {
  render() {
    return <AntDTabs {...this.props}></AntDTabs>;
  }
}

export { TabPane };
export default Tabs;



// WEBPACK FOOTER //
// ./client/modules/core/Tabs/index.tsx